/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import { extendTheme } from '@chakra-ui/react';
import styled, { createGlobalStyle } from 'styled-components';
import { respond } from './mixins';

export const chakraTheme = extendTheme({
  fonts: {
    heading: 'var(--font-family-alt)',
    body: 'var(--font-family-alt)',
  },
  colors: {
    primary: {
      500: 'var(--ion-color-primary)',
    },
    blue: {
      50: '#E5F0FF',
      100: '#B8D4FF',
      200: '#8AB9FF',
      300: '#5C9DFF',
      400: '#2E82FF',
      500: '#0066FF',
      600: '#0052CC',
      700: '#003D99',
      800: '#002966',
      900: '#001433',
    },
    ligthBlue: {
      50: '#F6FFFF',
      500: '#D4FAFA',
      600: '#C7EEEE',
      700: '#A0C7C7',
    },
    darkBlue: {
      200: '#5F809D',
      300: '#2F4959',
      400: '#0C2C47',
      500: '#061D31',
    },
    newGreen: {
      50: '#ECF6E0',
      100: '#DEF2C6',
      200: '#CFEDAC',
      300: '#C1E993',
      400: '#B2E479',
      500: '#A4E05F',
      600: '#7FC035',
      700: '#598823',
      800: '#335011',
      900: '#1C3301',
    },
  },
  components: {
    Modal: {
      baseStyle: {
        header: {
          fontSize: '1rem',
          color: 'gray.600',
        },
      },
    },
    Textarea: {
      baseStyle: {
        minHeight: '100px',
        padding: '10px',
      },
      sizes: {
        lg: {
          fontSize: '0.9rem',
        },
      },
    },
    Button: {
      baseStyle: {
        fontWeight: 600,
      },
      sizes: {
        md: {
          fontSize: '0.9rem',
        },
      },
      variants: {
        ghost: ({ colorScheme: c }: { colorScheme: string }) => ({
          bg: 'transparent',
          color: `${c}.500`,
          _hover: {
            bg: `${c}.50`,
            color: `${c}.600`,
          },
        }),
      },
    },
    Drawer: {
      variants: {
        alwaysOpen: {
          parts: ['dialog, dialogContainer'],
          dialog: {
            pointerEvents: 'auto',
          },
          dialogContainer: {
            pointerEvents: 'none',
          },
        },
      },
    },
  },
});
export const RealGlobalStyles = createGlobalStyle`
  body {
    --chakra-fonts-body: var(--font-family-alt);
    --type1-color: 53, 214, 104;
    --type2-color: 50, 176, 216;
    --type3-color: 183, 43, 164;
    --type4-color: 33, 113, 236;
    /* --chakra-colors-blue-500: var(--ion-color-primary); */
    .btn {
      &.btn-primary {
        background-color: rgba(var(--ion-color-primary-rgb), .9);
        color: #FFF;
        &:hover {
          background-color: rgba(var(--ion-color-primary-rgb), 1);
        }
      }
    }
    .video-js {
      button {
        outline: 0;
        &.vjs-big-play-button {
          right: 0;
          left: 0;
          margin: 0 auto;
          top: 50%;
          transform: translateY(-50%);
          padding: 0;
          border: none;
          background: #00000070;
          border-radius: 50%;
          width: 90%;
          max-width: 65px;
          display: flex;
          align-items: center;
          justify-content: center;
          height: auto;
          box-shadow: 1px 1px 30px 5px #0000006e;
          transition: 0.2s;
          z-index: 20;
          &:hover {
            background: #145dce;
          }
          .vjs-icon-placeholder {
            display: flex;
            height: 60px;
            align-items: center;
            justify-content: center;
            &:before {
              font-size: 3rem;
              position: relative;
              display: block;
              height: auto;
            }
          }
        }
      }
      &.vjs-playing {
        .vjs-big-play-button {
          display: none;
        }
      }
    }


    .me {
      background-color: #e8e8ff;
      color: var(--ion-color-primary);
      font-weight: 700;
      margin-right: 7px;
      padding: 2px 10px;
      margin: 0 10px;
      text-transform: uppercase;
      font-size: 0.7rem;
      border-radius: 4px;
      display: inline-block;
    }
    .rs-picker-menu {
      z-index: 2000 !important;
    }
    .rs-drawer-wrapper {
      .rs-drawer-right {
        ${respond.down('sm')} {
          width: 90%;
        }
      }
    }
    .chakra-popover__popper {
      z-index: var(--chakra-zIndices-popover);
    }
    .emoji-popover {
      min-width: 160px;
    }
    .rs-notification {
      font-family: var(--font-family-alt);
      top: 110px !important;
    } 
    .rs-tooltip {
      font-family: var(--font-family-alt);
      font-size: .85rem;
      font-weight: 400;
      &.placement-top {
        .rs-tooltip-arrow {
          border-top-color: var(--ion-color-primary);
        }
      }
      .rs-tooltip-inner {
        background: var(--ion-color-primary);
      }
    }

  }
`;

export const GlobalStyles = styled.div`
  position: static;

  .btn {
    background: none;
  }

  ion-icon {
    pointer-events: none;
  }
  ion-toast {
    &.response-success {
      font-family: var(--font-family-alt);
      font-weight: 500;
      --width: 350px;
      --height: 100px;
      margin-top: 50px;
      text-align: center;
      font-size: 1.1rem;
    }
  }
  .toolbar-container {
    align-items: flex-start;
  }
  ion-toolbar.episode-toolbar {
    --min-height: 500px;
    position: absolute;
    z-index: -1;
    pointer-events: none;
  }
  ion-header {
    position: absolute;
    z-index: 100;
    background: none;
    ion-toolbar {
      --background: none;
      --box-shadow: none;
    }
  }
  .header-md::after {
    background: none;
  }

  .episode-title {
    font-family: var(--font-family-alt);
    padding: 5px 0 5px 20px;
    font-weight: 400;
    letter-spacing: -0.5px;
    font-size: 1.4rem;
    color: #fff;
    /* position: relative; */
    font-size: 1.2rem;
    color: #fff;
    position: relative;
    height: 70px;
    text-shadow: 2px 2px 1px #00000073;
    background: #00000021;
    width: fit-content;
    border-radius: 0 0 10px 0;
    display: inline-flex;
    max-width: 380px;
    position: absolute;
    top: 0;
    .rs-avatar {
      border: 2px solid #fff;
    }
    > div {
      display: flex;
      align-items: center;
      span {
        padding: 0 30px 0 15px;
        width: 90%;
        white-space: normal;
      }
    }
    .btn-next-episode {
      position: absolute;
      right: 20px;
      font-family: var(--font-family-alt);
      --box-shadow: none;
      top: 0;
      text-transform: none;
      top: 50%;
      transform: translateY(-50%);
      margin: 0;
      border: 2px solid #ffffff36;
      border-radius: 50px;
      outline: 0;
      background: none;
      --background: transparent;
      overflow: hidden;
      --padding-top: 10px;
      --padding-bottom: 10px;
      font-size: 1rem;
      font-weight: 400;
      height: auto;
      --height: auto;
      display: none;
      i {
        margin: 0 10px;
        font-size: 22px;
      }
    }

    .episode-subtitle {
      text-transform: uppercase;
      font-size: 0.8rem;
      letter-spacing: 2px;
      font-weight: 500;
      color: rgba(var(--ion-color-light-rgb), 0.7);
    }
  }

  ion-button {
    letter-spacing: 0;
    font-weight: 600;
  }
  ion-tab-bar {
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    display: none;
    ion-label {
      font-size: 0.8rem;
      font-weight: 600;
      letter-spacing: -0.02em;
    }
  }
  ion-content.main {
    height: 100vh;
  }
  ion-modal {
    &.share-prompt-modal {
      .modal-wrapper {
        border-radius: 10px;
        box-shadow: 1px 1px 60px 4px #0000009e;
        opacity: 1;
        max-height: 480px;
        width: 90%;
        max-width: 800px;

        ion-toolbar {
          height: 45px;
          ion-button {
            --background: #f7f7f7;
            --background-focused: #f7f7f7;
            --background-hover: #f7f7f7;
            opacity: 0.5;
            transition: 0.1s;
            &:hover {
              background: #f7f7f7;

              opacity: 1;
            }
          }
        }

        ion-toolbar,
        ion-content {
          --background: #f7f7f7;
        }
      }
    }
  }

  .pulsate-fwd {
    -webkit-animation: pulsate-fwd 0.6s ease-in-out both;
    animation: pulsate-fwd 0.6s ease-in-out both;
  }
`;

export const WaveBottom: React.FC<{
  path: string;
  fill?: string;
  height?: string;
  type?: string;
}> = ({ path, fill, height, type }) => {
  // eslint-disable-next-line no-underscore-dangle
  const _height = height || 19;
  const pathVal: Record<string, string> = {
    '1':
      'M0.00,49.98 C152.93,60.69 349.20,-49.98 500.00,49.98 L500.00,150.00 L0.00,150.00 Z',
    '2':
      'M-31.59,0.50 C180.58,187.98 362.30,-31.08 500.00,49.98 L500.00,150.00 L-15.79,181.08 Z',
  };
  return (
    <div
      className={`wave-bottom wave-${type || 'default'}`}
      style={{ height: `${_height}px`, overflow: 'hidden' }}
    >
      <svg viewBox="0 0 500 150" preserveAspectRatio="none">
        <path
          d={`${pathVal[path]}`}
          style={{ stroke: 'none', fill: `${fill || '#f1f4f7'}` }}
        />
      </svg>
    </div>
  );
};
